import {Component, inject} from '@angular/core';
import {DxTabsModule} from "devextreme-angular";
import {ChecklistComplianceComponent} from "../checklist-compliance/checklist-compliance.component";
import {ChecklistConditionComponent} from "../checklist-condition/checklist-condition.component";
import { IncidentReportScoreComponent } from '../incident-reports/incident-report-score/incident-report-score.component';
import {AccessType, AuthService, PermissionType} from "@services";

@Component({
    selector: 'app-checklist-my-score',
    imports: [DxTabsModule, ChecklistComplianceComponent, ChecklistConditionComponent, IncidentReportScoreComponent],
    templateUrl: './checklist-my-score.component.html'
})
export class ChecklistMyScoreComponent {
    protected auth = inject(AuthService);

    allTabs = [
        {text: 'MHE Compliance', id: 0, permission: PermissionType.ChecklistCompliance},
        {text: 'MHE Status', id: 1, permission: PermissionType.ChecklistCondition},
        {text: 'Safety Incidents', id: 2,permission: PermissionType.IncidentReports,},
        {text: 'Safety Observations', id: 3,permission: PermissionType.IncidentReports,},
    ];

    tabs = this.allTabs.filter(t => this.auth.checkPermission(t.permission, AccessType.ViewOnly));

    selectedTab = this.tabs.length > 0 ? this.tabs[0] : null;

    onTabClick(e: any) {
        this.selectedTab = e.itemData;
    }
}
